
import { InjectionToken  } from '@angular/core';
import { SelectedItemsVisualizerOverlayRef } from './selected-items-visualizer-overlay-ref';
import { Observable } from 'rxjs';
import { ItemListInjectionToken } from './item-list-injection-token';
import { ItemNode } from '../models/item';
 


export const DIALOG_REF_TOKEN = new InjectionToken<SelectedItemsVisualizerOverlayRef>('DIALOG_REF_TOKEN');
export const SELECTED_ITEMS_STREAM = new InjectionToken<Observable<ItemNode[]>>('SELECTED_ITEMS_STREAM');
export const ITEM_LIST = new InjectionToken<ItemListInjectionToken>('ITEM_LIST');